import React from "react";
import { Box, Heading, Text, VStack } from "@chakra-ui/react";
import { useCustomTheme } from "../../../contexts/CustomThemeContext";

type Props = {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
};

const FinancePageShell: React.FC<Props> = ({ title, subtitle, children }) => {
  const { theme } = useCustomTheme();

  return (
    <Box p={{ base: 4, md: 6 }} bg={theme.background} minH="100%">
      <Box width={'100%'} mx="auto">
        <VStack align="stretch" spacing={6}>
          <Box>
            <Heading color={theme.text} size="lg">
              {title}
            </Heading>
            {subtitle ? (
              <Text color={theme.textMuted} mt={2}>
                {subtitle}
              </Text>
            ) : null}
          </Box>
          {children}
        </VStack>
      </Box>
    </Box>
  );
};

export default FinancePageShell;
